    <div class="connection-request-container">
        <div class="row">
            <ng-container *ngIf="showECHeader">
                <span class="col-12 ec-badge d-flex align-items-center pt-2"
                    title="{{ecProductFeed.ecHeaderText}}"
                    (click)="showTitle($event)">
                    <img class="ec-icon"
                        [src]='ecProductFeed.icon  | fitInImg :igs.imageGroup.fitin_500x500'
                        alt="ec badge icon"/>
                    <span class="ec-text ec-text-overflow ec-hide"
                        *ngIf="eCHeader">{{eCHeader? ecProductFeed.ecHeaderText: ''}}</span>
                    <span class="ec-gap"></span>
                </span>
            </ng-container>
        </div>
        <div class="row">
            <div class="col-12 channel-container">
                <div (click)="profilePicClicked()" [ngClass]="{'cursor-pointer': isStoriesAvailable(data.channel_id)}" class="clearfix d-flex">
                    <div class="float-left mr-2 cursor-pointer connection-profile-container">
                        <div class="position-relative"  [ngClass]="{'has-story': isStoriesAvailable(data.channel_id)}">
                        <!-- image -->
                        <!-- <app-user-pofile-pic  [profile_pic_image]="connection_pic_image"></app-user-pofile-pic> -->
                        <img class="box-size-40 rounded-circle story-item "
                        [src]='data?.channel_logo  | fitInImg :igs.imageGroup.fitin_500x500'
                            onerror="this.src='assets/themes/icons/channel-placeholder.svg'" />
                        </div>
                    </div>
                    <div class="float-left pl-0 cursor-pointer lh-1 channel-name-container"
                        >
                        <div class="d-table w-100 m-height-40px">
                            <div class="d-table-cell align-middle">
                                <div class="elips-content position-relative" [ngClass]="{'eccontainer-width':showECHeader}">
                                    <p class="custom-tooltip bottom text-capitalize">
                                        <span  class="paragraph-bold"
                                            [dataTestId]="data.channel_id"
                                            [dataTestIdName]="dataTestId.CHANNEL_USER_CARD_TITLE + '-' + callingFrom">{{data?.title}}
                                            <span *ngIf='data?.title.length>channelLength; ' class="tooltip-content secondary-paragraph">{{data?.title}}</span>
                                        </span>
                                    </p>
                                    <p class="primary-small">
                                        <span [dataTestId]="data.channel_id" [dataTestIdName]="dataTestId.CHANNEL_USER_CARD_POWERED_BY + '-' + callingFrom" class="connection-speciality color-grey-500">
                                            {{data?.powered_by_label}} {{data?.powered_name}}
                                        </span>
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- //subscribe channel -->
            <div [ngClass]="{'disabled-action': data?.content_visibility?.display!=1}"
                *ngIf="(this.mls.featureOnOffList.featureList.follow.value || !mls.userLoginFlow) && data?.subscribed_button_flag==1 && callingFrom != 'search_feed_card' && removechannelfollow !='channel_detail_feed_card'"  class="col-5 text-right pl-0 pt-1 follow-container">
                    <button *ngIf="data?.is_subscribed==0"
                        (click)="followChannel()"showSubscribeModal=true
                        class="btn-design small h-auto outline w-100">{{mls?.languageText?.channel_user_card?.key1}}<span *ngIf="mls?.is_lskey_display==1">(channel_user_card?.key1)</span>
                    </button>

                    <button *ngIf="data?.is_subscribed==1"
                        class="btn-design small h-auto filled-disabled w-100">
                        <img src="assets/themes/icons/right-tick-icon.svg" alt="following icon"> {{mls?.languageText?.channel_user_card?.key2}}<span *ngIf="mls?.is_lskey_display==1">(channel_user_card?.key2)</span></button>
            </div>
        </div>
    </div>

    <app-product-subscribe
       *ngIf="showSubscribeModal"
        (resetSubscribeModal)="backClicked()"
        [showSubscribeModal]="showSubscribeModal"
        [channelData]="subscribe_obj"
        (hasSubscribed)="hasSubscribed($event)">
    </app-product-subscribe>
